import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ItemMenu } from '@/core/components/database/menu';
import { NavegacaoService } from '@/core/services/navegacao/navegacao.service';
import { IconComponent } from '@/shared/components/ui/icon';
import { MenuComponent, MenuGatilhoDirective, MenuItemComponent } from '@/shared/components/ui/menu';

// Classes completas (o Tailwind só gera o que aparece inteiro no código).
// Item simples (ex.: Dashboard).
const CLASSES_ITEM =
  'flex items-center gap-2 whitespace-nowrap px-[0.875rem] text-sm font-medium text-rfy-subdued no-underline ' +
  'hover:bg-rfy-subtle hover:text-rfy-foreground-strong';
const CLASSES_ITEM_ATIVO =
  'flex items-center gap-2 whitespace-nowrap px-[0.875rem] text-sm font-semibold text-rfy-foreground-strong no-underline ' +
  'shadow-[inset_0_-2px_0_var(--rfy-primary)] hover:bg-rfy-subtle';

// Wrapper de grupo: o sublinhado aparece quando algum subitem é a rota atual.
const CLASSES_GRUPO = 'relative flex items-center';
const CLASSES_GRUPO_ATIVO = 'relative flex items-center shadow-[inset_0_-2px_0_var(--rfy-primary)]';

// Gatilho do grupo (fechado e aberto).
const CLASSES_GATILHO =
  'flex h-10 items-center gap-2 whitespace-nowrap rounded-controle px-[0.875rem] bg-[transparent] border-solid ' +
  'border-[0px] text-sm font-medium text-rfy-subdued cursor-pointer hover:bg-rfy-subtle hover:text-rfy-foreground-strong';
const CLASSES_GATILHO_ABERTO =
  'flex h-10 items-center gap-2 whitespace-nowrap rounded-controle px-[0.875rem] border-solid border-[0px] text-sm ' +
  'font-semibold bg-rfy-subtle text-rfy-foreground-strong cursor-pointer';

/** Subnav horizontal do layout horizontal. A topbar fica em `app-topnav`. */
@Component({
  selector: 'app-horizontal-topnav',
  standalone: true,
  imports: [RouterLink, IconComponent, MenuComponent, MenuGatilhoDirective, MenuItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './horizontal-topnav.component.html',
  host: { class: 'contents' },
})
export class HorizontalTopnavComponent {
  readonly navegacao = inject(NavegacaoService);

  // Só um grupo aberto por vez.
  readonly grupoAberto = signal<string | null>(null);

  readonly CLASSES_ITEM = CLASSES_ITEM;
  readonly CLASSES_ITEM_ATIVO = CLASSES_ITEM_ATIVO;
  readonly CLASSES_GRUPO = CLASSES_GRUPO;
  readonly CLASSES_GRUPO_ATIVO = CLASSES_GRUPO_ATIVO;
  readonly CLASSES_GATILHO = CLASSES_GATILHO;
  readonly CLASSES_GATILHO_ABERTO = CLASSES_GATILHO_ABERTO;

  /** Atualiza o grupo aberto quando o menu abre ou fecha. */
  definirAberto(rotulo: string, aberto: boolean): void {
    this.grupoAberto.set(aberto ? rotulo : this.grupoAberto() === rotulo ? null : this.grupoAberto());
  }

  /** Grupo tem o subitem da rota atual. */
  grupoAtivo(grupo: ItemMenu): boolean {
    return grupo.submenu?.some((sub) => sub.rota === this.navegacao.rotaAtiva()) ?? false;
  }
}
